import React, { useState } from 'react'

import { Icon } from '@app/components/util'
import { LntIconButton } from '@app/components/base'
import { ExtendedDropdown } from '@app/components'

import variables from '@app/theme/variables'

import { ICON_NAME } from '@app/constants/icon'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import { isEmptyArray } from '@app/utils'

import type { DropdownData, DropdownMenuItem } from '@app/types/dropdown'
import type { TableSettingTriggerProps, TableSettingButtonProps } from './types'

const Trigger: React.FC<TableSettingTriggerProps> = ({ isOpen, toggle, triggerProps, ...restProps }) => {
  const textColor = isOpen ? variables.brandBlue : undefined

  return (
    <LntIconButton
      { ...restProps }
      { ...triggerProps }
      textColor={ textColor }
      type={ BUTTON_TYPE.text }
      size={ SIZE.small }
      icon={ <Icon name={ ICON_NAME.setting } /> }
      onClick={ toggle }
    />
  )
}

export const TableSettingButton: React.FC<TableSettingButtonProps> = ({ onSelect, ...restProps }) => {
  const [isAcceptDisabled, setIsAcceptDisabled] = useState(false)

  const handleSelect = (data: DropdownData[], items: DropdownMenuItem[], item?: DropdownMenuItem): void => {
    onSelect?.(data, items, item)
    setIsAcceptDisabled(isEmptyArray(data))
  }

  return (
    <ExtendedDropdown
      { ...restProps }
      isSortable
      isMultiple
      isSearchable
      trigger={ Trigger }
      toolbar={ { accept: { disabled: isAcceptDisabled }, reset: true } }
      onSelect={ handleSelect }
    />
  )
}
